import React from 'react';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import styles from './GameBoard.module.css';

const RoundIndicator = () => {
    const currentRound = useSelector((state) => state.game.currentRound || 1);
    const totalRounds = 3;

    return (
        <motion.div
            className={styles.roundIndicator}
            initial={{ x: 30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.4 }}
        >
            <span className={styles.roundLabel}>Round {currentRound}/{totalRounds}</span>
            <div className={styles.roundDots}>
                {Array.from({ length: totalRounds }, (_, index) => {
                    const roundNumber = index + 1;
                    const isActive = roundNumber === currentRound;
                    const isCompleted = roundNumber < currentRound;

                    return (
                        <motion.span
                            key={roundNumber}
                            className={`${styles.roundDot} ${isActive ? styles.roundDotActive : ''} ${isCompleted ? styles.roundDotCompleted : ''}`}
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: index * 0.08 }}
                        />
                    );
                })}
            </div>
        </motion.div>
    );
};

export default RoundIndicator;
